var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content-section"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"cols":"12","md":"10"}},[_c('h3',{staticClass:"ada-h3 mb-4"},[_vm._v(_vm._s(_vm.adapters.title))]),_c('AdapterOwl',{attrs:{"adapters":_vm.adapters.items,"lg":"6"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }